// Utils
import axios, { endpoints } from 'src/utils/axios';

const URL = endpoints.recent_record_views.root;

// ----------------------------------------------------------------------

export async function recentRecordViewsGet() {
  const response = await axios.get(URL);
  return response.data;
}
